import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Landing from './Landing';
import Extensions from './Extensions';
import Projects from './Projects';
import Games from './Games';
import AuthDeckDownload from './AuthDeckDownload';
import BlogPage from './BlogPage';
import DockerGuidePage from './DockerGuidePage';
import CloudflareTunnelGuidePage from './CloudflareTunnelGuidePage';
import CadenceSystemDesignPage from './CadenceSystemDesignPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/extensions" element={<Extensions />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/authdeck-download" element={<AuthDeckDownload />} />
          <Route path="/games" element={<Games />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/cadence-system-design" element={<CadenceSystemDesignPage />} />
          <Route path="/blogs/docker-guide" element={<DockerGuidePage />} />
          <Route path="/blogs/cloudflare-tunnel-guide" element={<CloudflareTunnelGuidePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
